import { render } from "./FotodePerfil.vue?vue&type=template&id=f22253f6&scoped=true"
import script from "./FotodePerfil.vue?vue&type=script&lang=js"
export * from "./FotodePerfil.vue?vue&type=script&lang=js"

import "./FotodePerfil.vue?vue&type=style&index=0&id=f22253f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22253f6"]])

export default __exports__